import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: `winfinity/game/list`,
  converter,
  getHeaders: () => ({
    'Content-Type': 'application/json',
    headers: { 'x-partner-name': projectName },
  }),

  sessionUrlData: {
    url: `winfinity/game/launch`,
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-authorization': parseCookies(), 'x-partner-name': projectName },
    }),
    getQuery: params => {
      const base = `?game_id=${params.id}&player_device=${params.isMobile ? 2 : 1}&deposit_url=${encodeURIComponent(
        `${location.origin}/deposit`,
      )}&home_url=${location.origin}`;

      return params.tableId ? `${base}&table_id=${params.tableId}` : base;
    },
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
  },
};
